import { useQuery } from "@tanstack/react-query";
import {
  buildPurchaseOrdersListCountPayload,
  fetchPurchaseOrdersListCount,
} from "../../services/purchaseOrders/purchaseOrdersApi";
import { poQueryCache } from "./cacheTimes";
import { purchaseOrderKeys } from "./queryKeys";

/**
 * Quick-filter chip counts — `new_purchase_orders_list_count`.
 * Refetch on every listing visit; respects vendor filter and search text.
 */
export function usePurchaseOrdersListCountQuery({
  auth,
  merchantId,
  vendorId = "all",
  search = "",
  enabled = true,
}) {
  const vendorKey = vendorId === "all" ? "all" : String(vendorId);
  const searchKey = String(search || "").trim();

  return useQuery({
    queryKey: purchaseOrderKeys.listCount(merchantId, vendorKey, searchKey),
    queryFn: ({ signal }) =>
      fetchPurchaseOrdersListCount(
        buildPurchaseOrdersListCountPayload(
          auth,
          merchantId,
          vendorKey,
          searchKey
        ),
        signal
      ),
    enabled: Boolean(enabled && merchantId && auth?.token),
    ...poQueryCache.count,
    refetchOnMount: "always",
  });
}
